















































































import Vue from 'vue'
import Component from 'vue-class-component'
import Card from '@/components/Card.vue'
import Icon from '@/components/Icon.vue'
import { getModule } from 'vuex-module-decorators'
import { ChainModule } from '@/store/modules/chain.module'
import { UserModule } from '@/store/modules/user.module'
import { EAlertStatus, EAlertTypePriority, IAlert, IAlertType } from '@zunta/configurations'
import { getFilePathByKey } from '@/utils/helpers'
import ScrollView from '@/components/ScrollView.vue'
import Alert from './Alert.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'

@Component({
  props: {
  },
  components: {
    Card,
    Icon,
    ScrollView,
    Alert,
    DateTimeLabel
  }
})
export default class AllAlerts extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store);
  userModuleInstance: UserModule = getModule(UserModule, this.$store);
  EAlertStatus: any = EAlertStatus;
  getFilePathByKey: Function = getFilePathByKey;
  alertIndex: number = 0;
  EAlertTypePriority: any = EAlertTypePriority;
  get alerts () {
    return this.$store.state.user.alerts
  }

  get currentAlert () {
    return this.alerts[this.alertIndex]
  }

  mounted () {
    this.$eventBus.$emit('Root:disableScroll')
  }
  beforeDestroy () {
    this.$eventBus.$emit('Root:enableScroll')
  }

  activateTask (index: number) {
    this.alertIndex = index
  }

  getStatusStatusLabel (status: EAlertStatus) {
    switch (status) {
      case EAlertStatus.NEW:
        return 'New'
      case EAlertStatus.IGNORED:
        return 'Ignored'
      case EAlertStatus.LOOKED_INTO:
        return 'Completed'
      case EAlertStatus.POSTPONED:
        return 'Postponed'
      default:
        return 'Unknown'
    }
  }

  getToolTipLabel (alert: IAlert) {
    switch ((alert.alertType as IAlertType).priority) {
      case EAlertTypePriority.LOW:
        return 'Not Important'
      case EAlertTypePriority.MEDIUM:
        return 'Medium Priority'
      case EAlertTypePriority.HIGH:
        return 'Very Important'
    }
  }
}
